import * as React from 'react';

import styled from 'react-emotion';

const Container = styled('div')`
  color: black;
  width: 100%;
  margin: 10px;
`;

const SectionHeading = styled('h1')`
  font-size: 30px;
  margin-left: 10px;
  margin-top: 20px;
  font-weight: 700;
`;
const Question = styled('h2')`
  margin-top: 10px;
  font-size: 20px;
  margin-left: 10px;
  font-weight: 500;
`;

const Answer = styled('p')`
  font-size: 14px;
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 25px;
`;

const FAQ = () => {
  return (
    <Container>
      <SectionHeading>Frequently Asked Questions</SectionHeading>
      <hr />
      <Question>Have you announced token generation event/presale?</Question>
      <Answer>
        No announcement has been made regarding the token generation event. Stay
        tuned!
      </Answer>
      <Question>What is GenesisAI?</Question>
      <Answer>
        GenesisAI is a decentralized, blockchain-based marketplace for AI
        services. It is a platform connecting companies in need of AI services
        with companies that would like to monetize their AI code. GenesisAI is a
        protocol (a bunch of smart contracts) that specifies how different AIs
        can connect with each other. Using our platform, companies can request
        various AI services, pay the appropriate amount to a service provider
        using our native token and have AI work done for them. GenesisAI creates
        a new type of economy: AI-to-AI economy.
      </Answer>

      <Question>What problem does GenesisAI solve?</Question>
      <Answer>
        Currently, there are fundamental problems with AI that holds the whole
        AI innovation back: there is no communication among AIs; there is no way
        for AIs to exchange data, trade services, learn from each other and
        leverage their capabilities. Furthermore, 99% of companies are in need
        of AI services, as they want to use AI to do things faster, smarter and
        cheaper. However, most of these companies cannot afford their own team
        of experts, nor do they have enough technical capabilities to correctly
        determine from which open-source APIs to grab AI code. GenesisAI helps
        companies in need of AI services to connect with companies who would
        like to monetize their AIs. We are matching unused resources (in-house
        developed AIs and open source Github AI code) with companies in need of
        these resources. The connector of these two parties will unlock
        trillions of dollars in value. GenesisAI’s platform enables AIs to
        connect with each other, trade services, exchange data and leverage
        their capabilities. It solves the most important problem in the field of
        AI: lack of connectivity among different AIs.
      </Answer>

      <Question>Why is your native token necessary?</Question>
      <Answer>
        We are creating a native token that will be developed on top of
        Ethereum. We decided to develop our own token instead of using the USD
        or any other fiat currency, because of 4 major reasons: Means of the
        transaction in the marketplace is the most important part of the
        marketplace. Our ideology of creating a decentralized marketplace
        requires means of transaction that is not tied to, or controlled by any
        government in the world. There will be thousands of micro-transactions
        happening on our network. Using the USD in microtransactions does not
        make sense because it has fixed costs. Furthermore, international
        payments in USD are extremely expensive. It is our belief that we should
        not exclude anybody to participate in building AI-to-AI economy because
        a person or an organization might not have easy access to the USD. Our
        native tokens will enable cheaper, faster, and more secure transactions.
        We decided to develop our native token instead of relying on already
        existing tokens because of 3 reasons: First, we need to reward
        beneficial AI players with our native token. Rewarding beneficial
        network players with native tokens is the least costly and most
        effective way. Second, we need a token that is optimized for the AI to
        AI economy. There will be thousands of transactions happening during a
        day, or even a second among different AIs. An optimized native token
        will help us to scale the marketplace without any problems. It is our
        long-term goal to create the first truly autonomous, decentralized
        organization. Network participants will make decisions regarding the
        AI-to-AI economy protocols. The amount of voting power of an AI node in
        governance will be determined by the amount of tokens held by the node,
        as well as by its reputation. Simply put, the GAI token is a utility
        token, that is used as a mean for AI-to-AI transactions. Therefore, our
        token mainly has a consumptive use. The GAI token can be acquired during
        the token generation event (details will be announced).
      </Answer>
    </Container>
  );
};

export default FAQ;



// WEBPACK FOOTER //
// ./src/routes/Dashboard/FAQ/index.tsx